import React from 'react';
import { Button } from '@frontend/shadcn/components/ui/button';
import { cn } from '@frontend/shadcn/lib/utils';
import { XmarkIcon } from '@revfluence/fresh-icons/solid/esm';

interface ImagePreviewProps {
  imageUrl: string;
  onRemove: () => void;
  altText?: string;
  className?: string;
  allowChange?: boolean;
  onMediaSelect?: (base64Image: string) => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  imageUrl,
  onRemove,
  altText = 'Preview',
  className = '',
  allowChange = false,
  onMediaSelect,
}) => {
  const handleMediaSelect = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,video/*';
    input.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          onMediaSelect?.(reader.result as string);
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  return (
    <div className={cn('relative w-[88px] h-[88px]', className)}>
      <img
        src={imageUrl}
        alt={altText}
        className="w-full h-full object-cover rounded-2xl"
        onClick={allowChange ? handleMediaSelect : undefined}
        style={{ cursor: allowChange ? 'pointer' : 'default' }}
      />
      <Button
        variant="secondary"
        size="smallIcon"
        className="absolute top-2 right-2"
        onClick={onRemove}
        aria-label="Remove image"
      >
        <XmarkIcon />
      </Button>
    </div>
  );
};
